<!--  -->
<template>
  <div class="senadtime">
    <div v-if="type==1" class="taewr" style="margin-right:10px">
      <el-select v-model="date.hours1" filterable placeholder="请选择" style="width:90px" @change="datechange">
        <el-option
          v-for="items in houroptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">时</div>
    </div><div v-else class="taewr" style="margin-right:10px">
      <el-select v-model="date.hours" filterable placeholder="请选择" style="width:90px" @change="datechange">
        <el-option
          v-for="items in houroptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">时</div>
    </div>
    <div v-if="type==1" class="taewr" style="margin-right:10px">
      <el-select
        v-model="date.minutes1"
        filterable
        placeholder="请选择"
        style="width:90px"
        @change="datechange"
      >
        <el-option
          v-for="items in minutesoptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">分</div>
    </div><div v-else class="taewr" style="margin-right:10px">
      <el-select
        v-model="date.minutes"
        filterable
        placeholder="请选择"
        style="width:90px"
        @change="datechange"
      >
        <el-option
          v-for="items in minutesoptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">分</div>
    </div>
    <div v-if="type==1" class="taewr" style="margin-right:10px">
      <el-select v-model="date.seconds1" filterable placeholder="请选择" style="width:90px" @change="datechange">
        <el-option
          v-for="items in secondsoptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">秒</div>
    </div>  <div v-else class="taewr" style="margin-right:10px">
      <el-select v-model="date.seconds" filterable placeholder="请选择" style="width:90px" @change="datechange">
        <el-option
          v-for="items in secondsoptions"
          :key="items.value"
          :label="items.label"
          :value="items.value"
        />
      </el-select>
      <div class="tiwmebox">秒</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Adddate',
  components: {},
  // eslint-disable-next-line vue/require-prop-types, vue/prop-name-casing
  props: ['houroptions', 'minutesoptions', 'secondsoptions', 'changedate', 'type', 'formatreply_interval_min', 'formatreply_interval_max', 'initdatemin', 'initdatemax'],
  data() {
    return {
      date: {
        hours1: '0',
        minutes1: '0',
        seconds1: '10',
        hours: '1',
        minutes: '0',
        seconds: '0'
      }
    }
  },
  computed: {

  },
  watch: {
    'formatreply_interval_min': {
      handler(val, old) {
        const timeString = val
        if (val) {
          const [hours, minutes, seconds] = timeString.split(':').map(Number)
          this.date.hours1 = hours
          this.date.minutes1 = minutes
          this.date.seconds1 = seconds
        }
      },
      immediate: true,
      deep: true
    },
    'formatreply_interval_max': {
      handler(val, old) {
        const timeString = val
        if (val) {
          const [hours1, minutes, seconds] = timeString.split(':').map(Number)
          this.date.hours = hours1
          this.date.minutes = minutes
          this.date.seconds = seconds
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeCreate() {
  },
  created() {
  },
  mounted() {

  },
  methods: {
    datechange() {
      if (this.type === 1) {
        const date = this.datecomputed()
        this.changedate(date, 1)
      } else if (this.type === 2) {
        const date = this.datecomputed()
        this.changedate(date, 2)
      }
    },
    datecomputed() {
      if (this.type === 1) {
        const h = parseInt(this.date.hours1) || 0
        const m = parseInt(this.date.minutes1) || 0
        const s = parseInt(this.date.seconds1) || 0
        const date = h * 3600 + m * 60 + s
        return date
      } else {
        const h = parseInt(this.date.hours) || 0
        const m = parseInt(this.date.minutes) || 0
        const s = parseInt(this.date.seconds) || 0
        const date = h * 3600 + m * 60 + s
        return date
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

.addbutton{
margin-bottom: 20px;
}
.sp_view{
  padding: 30px;
}
.frame {
        width:65%;
  }
  .conter{
    display: flex;
  }
  .senadtime{
      display: flex;
      align-items: center;
    }
    .taewr{
  display: flex;
  align-items: center;
  }

.copy_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 34px;
}
.copy_boxr{
  display: flex;
  align-items: center;
}
.taewr{
  display: flex;
  align-items: center;
  }
.tiwmebox{
  width: 50px;
  background: #f4f7f7;
  height: 36px;
  border: 1px solid #cccccc;
  border-left: 0px;
  text-align: center;
  line-height: 36px;
  color: #61686b;
  border-radius: 0px 5px 5px 0px;
  }
  .tiwmeboxr{
    width: 50px;
    background: #f4f7f7;
    height: 36px;
    border: 1px solid #cccccc;
    text-align: center;
    line-height: 36px;
    color: #61686b;
    border-radius: 5px;
  }
  .ca_boxr{
    margin-right: 17px;
    width: 50px;
    text-align: right;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
  .ca_boxre{
    width: 50px;
    text-align: right;
    margin-right:16px;
    color: rgb(169, 162, 151);
    font-size: 14px;
    font-weight: 700;
  }
  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
  ::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
    }
    .tactics_box{
      padding: 20px 20px 40px 20px;
    }
    .sum_box{
      position: fixed;
      left: 0;
      bottom: -20px;
      margin-left: 30px;
    }
    .sava_box{
      position: fixed;
      bottom: 10px;
      left: 286px;
    }

    .senadtime{
      display: flex;
      align-items: center;
    }
</style>
